export default "__VITE_ASSET__d46ad972__"